// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610220035/js/" + chunkId + "." + {"44":"d31395bc","225":"18e2e75c","481":"0ce51130","486":"ebe1134a","770":"9c635183"}[chunkId] + ".0.28600942458396916.chunk.js";
};